import {StringDatePipe} from './string-date.pipe';
import {AbsValuePipe} from './abs-value.pipe';
import {MeterValueString} from './meter-value-string-pipe';
import {CheckDataPipe} from './check-data.pipe';
import {SafeUrlPipe} from './safe-url.pipe';
import {NgModule} from '@angular/core';
import {MonthNameDate} from './month-name-date.pipe';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MonthDifferencePipe} from './month-difference.pipe';
import {WrapperPipe} from './wrapper.pipe';
import {TimezonePipe} from './timezone.pipe';
import {SafariDatePipe} from './safari-date.pipe';
import {DeltaDesc} from './delta-desc.pipe';
import {DateService} from '../_service/date.service';
import {ShortDatePipe} from './short-date.pipe';
import {NumberFormatPipe} from './number-format.pipe';
import {ClearTimezonePipe} from "./clear-timezone.pipe";
import {BytesToMBytesPipe} from './bytes-to-mbytes.pipe';
import {SafeHtmlPipe} from "./safe-html.pipe";
import {SafeIconPipe} from "./safe-icon.pipe";
import {UtcToLocalTimezonePipe} from "./utc-to-local-timezone.pipe";
import {CheckNumberDataPipe} from "./check-number-data.pipe";
/**
 * Created by Rumyantsev Daniil on 13.04.2018.
 */

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    StringDatePipe,
    AbsValuePipe,
    MeterValueString,
    CheckDataPipe,
    CheckNumberDataPipe,
    SafeUrlPipe,
    MonthNameDate,
    MonthDifferencePipe,
    WrapperPipe,
    TimezonePipe,
    SafariDatePipe,
    SafeHtmlPipe,
    ClearTimezonePipe,
    DeltaDesc,
    ShortDatePipe,
    NumberFormatPipe,
    BytesToMBytesPipe,
    SafeIconPipe,
    UtcToLocalTimezonePipe
  ],
  exports: [
    StringDatePipe,
    AbsValuePipe,
    MeterValueString,
    CheckDataPipe,
    CheckNumberDataPipe,
    SafeUrlPipe,
    SafeHtmlPipe,
    MonthNameDate,
    MonthDifferencePipe,
    WrapperPipe,
    TimezonePipe,
    ClearTimezonePipe,
    SafariDatePipe,
    DeltaDesc,
    ShortDatePipe,
    NumberFormatPipe,
    BytesToMBytesPipe,
    SafeIconPipe,
    UtcToLocalTimezonePipe
  ],
  providers: [
    DateService,

  ]
})
export class PipesModule {

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/pipes-module.ts